import { Switch } from '@orobix/orobix-fe-components'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { DatasetSelect } from '../../DatasetSelect'
import { SelectOption } from '../../DatasetSelect/types'

type DatasetFilterProps = {
  productId: number
  initialValue?: string[]
  initialExclude?: boolean
  onChange: (v: readonly SelectOption[]) => void
  onExcludeChange: (exclude: boolean) => void
}

const DatasetFilter = ({
  productId,
  initialValue,
  initialExclude = false,
  onChange,
  onExcludeChange,
}: DatasetFilterProps) => {
  const { t } = useTranslation()

  const [value, setValue] = useState<readonly SelectOption[]>([])
  const [exclude, setExclude] = useState(initialExclude)

  // Update exclude when initialExclude changes
  useEffect(() => {
    setExclude(initialExclude)
  }, [initialExclude])

  return (
    <>
      <DatasetSelect
        name="datasetFilter"
        productId={productId}
        value={value}
        initialValueIds={initialValue}
        onChange={(v) => {
          setValue(v)
          onChange(v)
          // Reset exclude when selection is cleared
          if (v.length === 0 && exclude) {
            setExclude(false)
            onExcludeChange(false)
          }
        }}
        label={t('Dataset')}
        placeholder={t('Filter...')}
      />
      <Switch
        id="datasetExcludeSwitch"
        text={t('Exclude selected datasets')}
        isToggled={exclude}
        disabled={value.length === 0}
        onToggle={() => {
          const isExclude = !exclude
          setExclude(isExclude)
          onExcludeChange(isExclude)
        }}
      />
    </>
  )
}

export default DatasetFilter
